import axios from 'axios'
import * as React from 'react'
import { useRouter } from 'next/router'

export default function ProtectedPage() {
  const router = useRouter()
  const { pageId, siteId, redirectLink } = router.query

  const [password, setPassword] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [rememberchecked, setRememberChecked] = React.useState(false)

  const handleSubmit = (event) => {
    setLoading(true)
    event.preventDefault()
    axios
      .post(
        `${process.env.NEXT_PUBLIC_BASE_API}/pages/verify-password/${siteId}/${pageId}/`,
        {
          password: password
        }
      )
      .then((resp) => {
        if (!resp.data.verification_status) {
          alert('Wrong Password. Try again')
          setLoading(false)
          return
        }

        // Remember user for an hour
        if (rememberchecked) {
          const oneHour = 60 * 60 * 1000
          const expires = new Date(new Date().getTime() + oneHour)
          document.cookie = `safe_to_page_${pageId}=true; expires=${expires.toUTCString()}; path=/`

          // remember subpages as well
          if (resp.data.subpage_ids) {
            resp.data.subpage_ids.forEach((subpageId) => {
              document.cookie = `safe_to_page_${subpageId}=true; expires=${expires.toUTCString()}; path=/`
            })
          }
        } else {
          // remember for 1 minute
          const oneMinute = 60 * 1000
          const expires = new Date(new Date().getTime() + oneMinute)
          document.cookie = `safe_to_page_${pageId}=true; expires=${expires.toUTCString()}; path=/`
        }

        setLoading(false)
        window.location.href = `${redirectLink}`
      })
      .catch((error) => {
        console.error("Couldn't verify password", error.message)
        alert('Oops. Something went wrong!')
        setLoading(false)
        return true
      })
  }

  return (
    <div className='password-wrapper'>
      <div className='html-embed-14'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='icon icon-tabler icon-tabler-lock'
          width='44'
          height='44'
          viewBox='0 0 24 24'
          strokeWidth='1'
          stroke='CurrentColor'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
          <rect x='5' y='11' width='14' height='10' rx='2'></rect>
          <circle cx='12' cy='16' r='1'></circle>
          <path d='M8 11v-4a4 4 0 0 1 8 0v4'></path>
        </svg>
      </div>
      <h1 className='heading-1'>This page is protected by the owner.</h1>
      <form onSubmit={handleSubmit}>
        <label className='label'>
          <p className='paragraph-3'>Password</p>
          <input
            className='input'
            type='password'
            placeholder='Enter you password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {!loading ? (
          <>
            <input className='submit' type='submit' value='Submit' />
            <div
              onClick={() => setRememberChecked(!rememberchecked)}
              className='remember-me-wrapper'
            >
              <div
                className={
                  'tickbox-notion ' +
                  (rememberchecked ? 'tickbox-notion--active' : '')
                }
              ></div>
              <div> Remember me</div>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>Loading...</div>
        )}
      </form>
    </div>
  )
}
